import { render, staticRenderFns } from "./directory-node.vue?vue&type=template&id=60d7a504&scoped=true"
import script from "./directory-node.vue?vue&type=script&lang=js"
export * from "./directory-node.vue?vue&type=script&lang=js"
import style0 from "./directory-node.vue?vue&type=style&index=0&id=60d7a504&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d7a504",
  null
  
)

export default component.exports